const SuccessIcon = () => (
	<div style={{ width: 115, height: 115 }}>
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 133 133'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g id='check-group' fill='none'>
				<circle
					id='filled-circle'
					fill='#2ecc71'
					cx='66.5'
					cy='66.5'
					r='54.5'
				/>
				<circle
					id='white-circle'
					fill='#FFFFFF'
					cx='66.5'
					cy='66.5'
					r='55.5'
				/>
				<circle
					id='outline'
					stroke='#2ecc71'
					strokeWidth='4'
					cx='66.5'
					cy='66.5'
					r='54.5'
				/>
				<polyline
					id='check'
					stroke='#FFFFFF'
					strokeWidth='5.5'
					points='41 70 56 85 92 49'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
		</svg>

		<style jsx>{`
			#check-group {
				animation: 0.32s ease-in-out 1.03s check-group;
				transform-origin: center;
			}
			#check {
				animation: 0.34s cubic-bezier(0.65, 0, 1, 1) 0.8s forwards
					check;
				stroke-dasharray: 0, 75px;
			}
			#outline {
				animation: 0.38s ease-in outline;
				transform-origin: center;
			}
			#white-circle {
				animation: 0.35s ease-in 0.35s forwards circle;
				transform-origin: center;
			}

			@keyframes outline {
				from {
					stroke-dasharray: 0, 345.576px;
				}
				to {
					stroke-dasharray: 345.576px, 345.576px;
				}
			}
			@keyframes circle {
				from {
					transform: scale(1);
				}
				to {
					transform: scale(0);
				}
			}
			@keyframes check {
				from {
					stroke-dasharray: 0, 75px;
				}
				to {
					stroke-dasharray: 75px, 75px;
				}
			}
			@keyframes check-group {
				from {
					transform: scale(1);
				}
				50% {
					transform: scale(1.09);
				}
				to {
					transform: scale(1);
				}
			}
		`}</style>
	</div>
);

export default SuccessIcon;
